import React, { useContext, createContext, useRef } from "react";
import { createPortal } from "react-dom";

const LayerContext = createContext(0);

const LayerWrapper = ({ children }) => {
	const parentZIndex = useContext(LayerContext);
	const newZIndex = parentZIndex + 999999;

	return (
		<LayerContext.Provider value={newZIndex}>
			{children}
		</LayerContext.Provider>
	);
};


const Popover = ({ children, style }) => {
	const zIndex = useContext(LayerContext);
	return (
		<div
			style={{
				zIndex,
				position: "relative",
				...style,
			}}>
			{children}
		</div>
	);
};

const Portal = ({ children, onClose }) => {
	const zIndex = useContext(LayerContext);
	const modalRef = useRef(null);

	
	const handleClickOutside = (event) => {
		if (modalRef.current && !modalRef.current.contains(event.target)) {
			onClose(); 
		}
	};

	return createPortal(
		<div
			style={{
				// height: "100vh",
				// width: "100vw",
				position: "fixed",
				inset: 0,
				background: "rgba(0, 0, 0, 0.33)", 
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				overflow: "auto",
				zIndex
			}}
			onClick={handleClickOutside}>
			<div ref={modalRef} >
				{children}
			</div>
		</div>,
		document.body
	);
};

const PopUpModal = ({ children, onClose }) => {
	return (
		<LayerWrapper>
			<Popover>
				<Portal onClose={onClose}>{children}</Portal>
			</Popover>
		</LayerWrapper>
	);
};

export default PopUpModal;
